import type { IconProps } from './types';

export const BoldIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}

    >
      <path
        d="M17.1787 15.8589C17.1785 13.788 15.4996 12.1089 13.4287 12.1089H7.75V19.6089H13.4287C15.4997 19.6088 17.1787 17.9299 17.1787 15.8589ZM15.25 7.50242C15.25 5.7864 13.8586 4.395 12.1426 4.395H7.75V10.6089H12.1426C13.8585 10.6089 15.2498 9.21832 15.25 7.50242ZM16.75 7.50242C16.7499 8.86141 16.1606 10.0821 15.2246 10.9253C17.2394 11.6588 18.6785 13.5905 18.6787 15.8589C18.6787 18.7583 16.3281 21.1088 13.4287 21.1089H7C6.58579 21.1089 6.25 20.7731 6.25 20.3589V3.645L6.25391 3.56785C6.29253 3.18988 6.61183 2.895 7 2.895H12.1426C14.687 2.895 16.75 4.95797 16.75 7.50242Z"
        fill={color}
      />
    </svg>
  );
};
